import { JSX } from 'react';
const IconLinkedIn = (): JSX.Element => {
  return (
    <>
      <path d="M23.0203 0H2.56875C1.58906 0 0.796875 0.773438 0.796875 1.72969V22.2656C0.796875 23.2219 1.58906 24 2.56875 24H23.0203C24 24 24.7969 23.2219 24.7969 22.2703V1.72969C24.7969 0.773438 24 0 23.0203 0ZM7.91719 20.4516H4.35469V8.99531H7.91719V20.4516ZM6.13594 7.43438C4.99219 7.43438 4.06875 6.51094 4.06875 5.37187C4.06875 4.23281 4.99219 3.30937 6.13594 3.30937C7.275 3.30937 8.19844 4.23281 8.19844 5.37187C8.19844 6.50625 7.275 7.43438 6.13594 7.43438ZM21.2484 20.4516H17.6906V14.8828C17.6906 13.5562 17.6672 11.8453 15.8391 11.8453C13.9875 11.8453 13.7062 13.2937 13.7062 14.7891V20.4516H10.1531V8.99531H13.5656V10.5609H13.6125C14.0859 9.66094 15.2484 8.70938 16.9781 8.70938C20.5828 8.70938 21.2484 11.0813 21.2484 14.1656V20.4516Z" />
    </>
  );
};

export default IconLinkedIn;
